module.exports = __webpack_public_path__ + "static/media/img_bg_gradient.0b942dcd.jpg";